import React from 'react'

const SendNoticeToMobile = () => {
  return (
    <div>SendNoticeToMobile</div>
  )
}

export default SendNoticeToMobile